module.exports = ['$scope', 'MyPlaylistModal', 'PlaylistsLoader', function SelectMyPlaylistModalCtrl($scope, MyPlaylistModal, PlaylistsLoader) {
    "use strict";

    // ---------------------------------
    // INIT DEFAULTS

    if ($scope.sharedTab === undefined) {
        $scope.sharedTab = true;
    }

    if ($scope.createButton === undefined) {
        $scope.createButton = true;
    }

    if ($scope.filter === undefined) {
        $scope.filter = true;
    }

    // ---------------------------------
    // LOADERS

    $scope.myPlaylistsLoader = new PlaylistsLoader({
        page: 0,
        sortBy: 'modifiedDate',
        sortOrder: 'DESC',
        textQuery: undefined,
        pageSize: 10,
        user: true
    }).getFirstPage();

    if ($scope.sharedTab) {
        $scope.sharedPlaylistsLoader = new PlaylistsLoader({
            sortBy: 'modifiedDate',
            sortOrder: 'DESC',
            sharedWithUser: true
        }).getFirstPage();
    }

    // ---------------------------------
    // SCOPE METHODS

    $scope.select = function (playlist) {
        $scope.$close(true, playlist);
    };

    $scope.onDrop = function (playlist) {
        $scope.$close(true, playlist);
    };

    $scope.create = function () {
        MyPlaylistModal.open({
            success: function (args) {
                $scope.$close(true, args[1]);
            }
        });
    };
}];


// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistclientbundle/Resources/js/angular/controllers/SelectMyPlaylistModalCtrl.js